import React from 'react';

import { BackportingEnums } from '../../../../../../generated/compat/backportingEnums';
import { SpecificRatiosInfo } from '../../../../../../generated/model/models';
import MatrixDataTable from '../../shared/MatrixDataTable';

export interface Props {
  data?: SpecificRatiosInfo[];
  ccy?: BackportingEnums.CcyEnum;
}

const TABLE_FIELDS = ['grossMarkup', 'berryRatio', 'ebit', 'netCostPlus', 'rndExpenseRatio'];

const TPSpecificRatios: React.FC<Props> = ({ data, ccy }) => {
  return (
    <MatrixDataTable
      title={'tpSpecificRatios'}
      translationsScope={'companies:companyRatios'}
      data={data}
      tableFields={TABLE_FIELDS}
      ccy={ccy}
    />
  );
};

export default TPSpecificRatios;
